// Конфигурация ботов для локальной игры

import {FACTIONS} from "../../constants/factions";
import {calcExpectedDamageDiceFace} from "../dice/calcExpectedDamageDiceFace";

// Отчет №25 (5500 симуляций волны 28, 4-группа A/B, ВКЛЮЧАЯ 6p; симуляция
// форсирует strong всем фракциям независимо от этого конфига — Δ NS−N валидна
// для каждой): сильный режим (прогноз песочницы ходов противников) оставлен
// ТОЛЬКО фракциям с положительной Δ NS−N — insectoids (+4.5), ventory (+3.9),
// leprechauns (+2.9), demons (+2.5), orcs (+1.5), elementals (+0.7).
// Остальным (Δ NS−N < 0 в отчете №25) сильный режим отключен во ВСЕХ типах
// игр: humans (−5.5), elves (−5.1), dwarves (−3.6), enlightened (−3.4),
// ratmen (−1.6), beastmen (−0.4). Все дельты этой волны внутри шумового
// диапазона ±6.5 п.п. (n≈450/группу-фракцию, см. simulation_report_24.md) —
// в т.ч. ratmen/elves/dwarves, стабильно державшиеся в strong три волны
// подряд (report 22/24), в этой волне ушли в минус. Правило (с отчета №21) —
// брать знак точечной оценки без порога значимости — применено как обычно;
// колебание трактуем как ожидаемый шум методологии, а не реальный сдвиг
// поведения. См. simulation_report_25.md.
export const BOT_STRONG_MODE_DISABLED_FACTIONS = new Set([
  FACTIONS.BEASTMEN, FACTIONS.DWARVES, FACTIONS.ELVES, FACTIONS.ENLIGHTENED,
  FACTIONS.HUMANS, FACTIONS.RATMEN,
]);

export const shouldUseBotStrongMode = (factionId) =>
  !BOT_STRONG_MODE_DISABLED_FACTIONS.has(factionId);

// Интервал между видимыми действиями бота (мс)
export const BOT_ACTION_INTERVAL_MS = 1500;
// Обучение: пауза между действиями скриптованного бота — игрок должен успевать
// видеть, что делает противник. Общая для глав, но глава может задать свою
// (botActionIntervalMs в ее конфиге, см. getTutorialBotActionIntervalMs)
export const TUTORIAL_BOT_ACTION_INTERVAL_MS = 3000;

// Сетевые игры: интервал между действиями бота случайный, чтобы ритм ходов
// не выдавал бота (у живых игроков паузы между действиями неравномерные)
export const ONLINE_BOT_ACTION_INTERVAL_MIN_MS = BOT_ACTION_INTERVAL_MS;
export const ONLINE_BOT_ACTION_INTERVAL_MAX_MS = 5000;

// Предел множителя скорости ботов в локальной партии (слайдер на
// HotSeatPlayersInitPage). У витрины главного меню свой предел — см.
// MENU_SHOWCASE_SPEED_MAX в configs/menuShowcase.js
export const DEMO_BOT_GAME_ACTIONS_SPEED_MAX_DELIMITER = 10;


// Ключ localStorage для выбранной пользователем скорости демо-партии
// (целочисленный множитель к стандартному интервалу действий ботов)
export const DEMO_BOT_GAME_SPEED_LOCAL_STORAGE_KEY = 'demoBotGameSpeed';

// Скорость хода ботов в локальной игре (HotSeatPlayersInitPage) по умолчанию —
// ×1, чтобы не менять существующий темп ходов для тех, кто ползунок не трогал
export const HOT_SEAT_BOT_GAME_SPEED_DEFAULT = 1;

// Ключ localStorage для выбранной пользователем скорости хода ботов в
// локальной (hot seat) игре — отдельный от ключа демо-партии в главном меню
export const HOT_SEAT_BOT_GAME_SPEED_LOCAL_STORAGE_KEY = 'hotSeatBotGameSpeed';

export const RANK_BOT_LOBBY_ACTION_INTERVAL_MULTIPLIER = 3;

export const getRandomOnlineBotActionDelayMs = () =>
  ONLINE_BOT_ACTION_INTERVAL_MIN_MS
  + Math.floor(Math.random() * (ONLINE_BOT_ACTION_INTERVAL_MAX_MS - ONLINE_BOT_ACTION_INTERVAL_MIN_MS + 1));

// Максимум шагов бота в рамках одной фазы (страховка от зацикливания)
export const BOT_MAX_STEPS_PER_PHASE = 40;

// Резерв монет в фазе строительства на найм отрядов в фазе войны.
// Применяется ТОЛЬКО когда у бота вообще нет отрядов (нужно возродить армию):
// равен цене самого дешевого отряда (d6). Экономика важнее накоплений.
export const BOT_CONSTRUCTION_COIN_RESERVE = 2;

// Веса оценочных функций
export const BOT_WEIGHTS = {
  // Ценность очков победы относительно монет (монеты конвертируются 2:1 в конце игры)
  COINS_TO_POINTS: 0.5,

  // Строительство
  KEY_POINT_CONTROL_PER_ROUND: 1.0, // множитель ценности ключевой точки за раунд владения
  // Базовый квартал строится только под конкретную цель (безусловной базы нет):
  QUARTER_SPECIAL_PLATFORM: 4, // платформа под спецстроение, когда свободных кварталов в городе нет
  QUARTER_EXPANSION_SYNERGY: 2, // открывает ячейки под нужные фермы/казармы
  OPENING_MINE_QUARTER_BOOST: 6, // раунды 1-2: квартал у рудника важнее второй фермы/казармы
  CENTRAL_QUARTER_BASE: 3,
  FARM_NEEDED: 9, // еда важнее казарм: без ферм армия голодает и погибает
  FARM_SURPLUS: 0, // лишние строения не строим: монеты конвертируются в очки 2:1
  BARRACKS_NEEDED: 8,
  BARRACKS_SURPLUS: 0,
  // Волна 19 (18.2): фермы/казармы раундов 1-5 тяготеют к важным ключевым
  // точкам (произведение близости и коэффициента важности точки)
  KP_PROXIMITY_ECONOMY_FACTOR: 2,
  BARRACKS_FRONTIER_PROXIMITY: 0.4, // за каждую ячейку близости к городам противника (в пределах 10)
  ROAD_TOWARD_KEY_POINT: 3,
  ROAD_KEY_POINT_ENABLEMENT_FACTOR: 0.5, // дорога несет часть ценности центрального квартала, который она откроет
  ROAD_KEY_POINT_APPROACH_FACTOR: 0.25, // затухающий подход к дальней ценной точке (цепочки дорог к центру)
  ROAD_SUPPLY_CORRIDOR: 0.3, // коридор снабжения к городам противника (× близость к ним)
  ROAD_DEFAULT: 0,
  REPAIR_OWN_BUILDING: 6,
  SPECIAL_INCOME_PER_ROUND: 0.9, // гильдия/храм: доходная ценность за раунд
  INFLUENCE_ROAD_PER_INCOME_PER_ROUND: 0.7, // дорога, открывающая пути влияния: ценность +1 дохода/раунд
  // Волна 25 (23.5): флат-бонус дороги, немедленно открывающей новый путь
  // влияния от УЖЕ построенной гильдии/храма (до 12 раунда включительно) —
  // без него такие дороги систематически проигрывали конкурс другим стройкам
  INFLUENCE_ROAD_IMMEDIATE_BONUS: 6,
  SAVINGS_GOAL_MIN_SCORE: 10, // минимальная ценность недоступного кандидата для накопительной цели
  PALACE_PER_REMAINING_ROUND: 1.1,
  WAREHOUSE_PER_ADJACENT_FARM_PER_ROUND: 0.35,
  // Волна 23 (22.1): AGRARIANISM — форс-скоринг бесплатной фермы фазы и буст
  // склада на квартале с 2+ смежными фермами (скидка политики + удвоение снабжения)
  AGRARIANISM_FREE_FARM_SCORE: 12,
  AGRARIANISM_WAREHOUSE_BOOST: 10,
  MILITARY_CAMP_PER_ADJACENT_BARRACKS_PER_ROUND: 0.35,
  ARSENAL_PER_CITY_QUARTER_PER_ROUND: 0.25,

  // Война
  CAPTURE_ENEMY_QUARTER: 100,
  DEFEND_OWN_CITY: 30,
  // Волна 32 (оборона, гейт isPreW32DefensePlayer): держатель квартала города
  // под риском захвата. Захвата нет, если на ЛЮБОМ квартале стоит свой отряд,
  // поэтому ценность первого держателя ~ очки захвата города (calcCityWinPoints)
  // в валюте CAPTURE_ENEMY_QUARTER (100 × eagerness)
  W32_CITY_HOLDER_BASE: 60,
  W32_CITY_HOLDER_PER_WIN_POINT: 8,
  W32_CITY_HOLDER_MAX: 130,
  W32_CITY_HOLDER_NEXT_ROUND_FACTOR: 0.4, // захват возможен только в следующем раунде
  W32_CITY_HOLDER_REINFORCE_FACTOR: 0.5, // второй держатель, когда первые не переживут ожидаемый урон
  MELEE_KILL: 40,
  MELEE_KILL_WIN_POINTS_FACTOR: 8,
  MELEE_TRADE_FACTOR: 4,
  SIEGE_CITY_GUARD: 15, // бонус за бой с отрядом, который стоит на квартале захватываемого города
  SUICIDE_PENALTY: 60,
  WEAK_UNIT_THREATENED_PENALTY: 20,
  STAY_ON_BARRACKS_TO_GROW: 6,
  APPROACH_TARGET_PER_CELL: 2,
  CAMPAIGN_APPROACH_PER_CELL: 5, // градиент к цели кампании сильнее общего продвижения
  LEPRECHAUN_STEAL_VALUE_FACTOR: 4, // ценность 1 украденной монеты в очках скоринга перемещения
  // «Сильный режим»: веса учета прогноза ходов противников
  STRONG_PREDICTED_THREAT_FACTOR: 1.5, // штраф за 1 прогнозного превосходящего размера смежно позиции
  STRONG_DEFEND_PREDICTED_FACTOR: 0.4, // доля DEFEND_OWN_CITY за квартал под прогнозируемым захватом
  STRONG_VACATED_CAPTURE_FACTOR: 0.5, // доля CAPTURE_ENEMY_QUARTER за квартал, который защита покинет
  STRONG_PREDICTED_APPROACH_SHOT_BONUS: 15, // бонус выстрела по цели, идущей к нам по прогнозу
  MANEUVER_RETREAT: 10,
  // Штрафы голода: единственное оправдание позиции вне снабжения — захват города.
  // Мягкие штрафы действуют только на финальном подступе к чужому городу
  // (кольцо осады), все прочие позиции вне снабжения — запретительный штраф
  OUT_OF_SUPPLY_REACH_PENALTY: 14,
  OUT_OF_SUPPLY_REACH_PENALTY_BIG_UNIT: 9, // крупный отряд терпит голод у стен города ради захвата
  OUT_OF_SUPPLY_HARD_PENALTY: 80, // не перебивается ни кампанией, ни убийством, ни обороной
  BLOCK_ENEMY_KEY_POINT_FACTOR: 4, // блокировка дохода ключевой точки противника (× ценность точки за раунд)
  DEMON_AURA_PER_ENEMY_UNIT: 3, // демоны: ценность ауры на 5 размера возле одного отряда противника
  INSECTOID_EMPTY_CELL_PENALTY: 2, // инсектоиды не растут на пустых ячейках (теряют +1 базового снабжения)
  ATTACK_BLOCKING_UNIT_FACTOR: 5, // бой с отрядом, блокирующим наши точки/строения (× ценность актива)
  NEUTRAL_ATTACK_CONTESTED_PENALTY: 25, // атака нейтралов при паритетных силах противника в 1 ходе рядом
  FORTRESS_OCCUPY_BONUS: 8, // занять свободную достроенную крепость
  FORTRESS_DEFEND_UNFINISHED_BONUS: 10, // занять свою недостроенную крепость при враге в 2 ячейках
  FORTRESS_BLOCK_ENEMY_BONUS: 6, // встать на/смежно недостроенной крепости противника (цель агрессии)
  ELF_KITE_BONUS: 5, // эльфы: позиция стреляет (дистанция 2-4 до врага), но недосягаема для ближнего боя
  ELF_BARRACKS_VACATE_PENALTY: 6, // эльф на своей казарме при бюджете на найм — блокирует платформу
  FARM_CENTRAL_SUPPLY_BONUS: 4, // ферма дотягивает снабжение до своего центрального города
  OUTMATCHED_ADVANCE_PENALTY: 18, // слабый неагрессивный бот не лезет в зону досягаемости сильного противника
  ROAD_CAMPAIGN_PATH_FACTOR: 0.6, // дорога на кратчайшем пути к цели захватной кампании (× близость)

  // Крысолюды: ферменная экономика вместо казарм (отряды бесплатны за снабжение)
  RATMEN_FARM_NEAR_WAREHOUSE_BONUS: 4, // ферма смежно складу дает больше снабжения
  RATMEN_WAREHOUSE_MULTIPLIER: 2.5, // ранний склад при 2+ смежных фермах — ядро экономики
  RATMEN_AGRARIANISM_BOOST: 6, // AGRARIANISM берем даже не самым дешевым на рынке
  RATMEN_ROAD_CORRIDOR_MULTIPLIER: 3, // рой d6 марширует к противнику по дорогам снабжения
  RATMEN_FARM_BLOCKING_PENALTY: 3, // выросший d6 на ферме блокирует следующий найм за снабжение
  RATMEN_FARM_HUB_VALUE: 8, // первый базовый квартал — хаб под склад с кольцом ферм
  RATMEN_FARM_NEAR_HUB_BONUS: 2, // ферма смежно базовому кварталу (будущему складу)
  RATMEN_FARM_FRONTIER_PER_CELL: 0.25, // фермы ближе к противнику — снабжение по пути волны
  DEMON_CENTER_DRIVE_PER_CELL: 0.4, // демоны тянутся к центру карты (аура + Великие руины)
  DWARVES_SERVARIANISM_MINE_GUARD: 4, // отряд 7+ у своего непокрытого рудника (+1 монета/раунд)

  // Волна 28 (25.2): элементали — форс-приоритет фермы, когда выпал редкий
  // подходящий элемент (иначе жетон сгорает впустую), и бонус кластеризации
  // первых 2 ферм у одного базового квартала (под будущий склад)
  ELEMENTALS_FORCED_FARM_SCORE: 600,
  ELEMENTALS_FARM_HUB_BONUS: 3,

  // Волна 20 (19.1/19.2): крупные простаивающие отряды (size>=8, либо >=50%
  // максимума у экономических/агрессивных архетипов) без кампании тянутся к
  // своему прифронтовому городу (ближайшему к живому противнику) сильнее
  // обычного градиента APPROACH_TARGET_PER_CELL — иначе застревают в тылу
  IDLE_ARMY_FRONTIER_PER_CELL: 6,
  // Волна 20 (19.4): казарма/ферма в центральной зоне поля (<=4 ячеек от центра)
  CENTRAL_CITY_ECONOMY_FACTOR: 3,
  // Волна 20 (19.7): ферма, дающая снабжение отряду, не получившему его в этом
  // раунде войны, — критичный приоритет над обычной экономикой
  FARM_UNSUPPLIED_UNIT_BONUS: 14,
  // Волна 20 (19.9): катапульта противника — приоритетная цель ближнего боя
  // даже при невыгодном размене (её собственная боевая ценность низкая)
  CATAPULT_TARGET_BONUS: 12,
  // Волна 27 (24.2): эльф-кайтер — приоритетная цель ближнего боя: смежная
  // позиция навязывает бой до отхода (стрельба по смежным не работает)
  ELF_MELEE_HUNT_BONUS: 12,
  // Волна 20 (19.11): цепочка строительства тяготеет к ячейкам рядом с целью
  // активной (любого типа) кампании отряда — не только к пути дороги
  CAMPAIGN_DESTINATION_PROXIMITY_FACTOR: 0.5,
};

// С какого раунда крысолюды строят казарму и нанимают кавалерию d12/d8
export const RATMEN_CAVALRY_ROUND = 7;

// Волна 28 (25.2, смягчено по итогам пробного A/B на закрытом пуле
// ratmen/insectoids/elementals — simulation_report_25_3faction_probe100.md):
// элементалей казарм не больше, чем ферм + этот запас. Было 2 — просело
// против плотной раш-агрессии (мало гарнизона), поднято до 3
export const ELEMENTALS_BARRACKS_FARM_CAP_MARGIN = 3;

// Профицит монет: с этого запаса ищем дополнительные стоки трат
// (дворцы, элитные отряды, найм размера). Просвещенных не касается — им копить выгодно.
export const BOT_COIN_SURPLUS_THRESHOLD = 20;

// Глубокий профицит: мертвый капитал конвертируется в размер армии
// даже сквозь кросс-фазовый резерв накоплений
export const BOT_COIN_DEEP_SURPLUS = 30;

// Минимальный размер отряда, при котором он не считается "слабым"
export const BOT_WEAK_UNIT_SIZE = 2;

// Средний ожидаемый штраф суммы двух костей урона — из самих граней (сейчас
// {-3,-2,-1,-1,0,0}: каждая кость в среднем -7/6, штраф 7/3, около 2.33)
export const BOT_EXPECTED_DICE_PENALTY = -2 * calcExpectedDamageDiceFace();
